import { Link } from "react-router-dom";

import { Navigation } from "../components/Navigation";

export function NotFoundPage() {
  return (
    <>
      <Navigation />
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900">Page not found</h1>
          <p className="mt-2 text-gray-600">
            The page you're looking for doesn't exist.
          </p>
          <Link
            to="/"
            className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Go to leaderboard
          </Link>
        </div>
      </div>
    </>
  );
}
